import {service, serviceForm} from '@/utils/request';  // 注意路径别名 @ 指向 src/

//用户登录
export const login = (data) => {
    const json = JSON.stringify(data);
    return service.post('/api/channel/login', {param: json});
};


//修改用户信息
export const saveUser = (data) => {
    const json = JSON.stringify(data);
    return service.post('/api/channel/saveUser', {param: json});
};

//获取用户信息
export const getUserInfo = (data) => {
    const json = JSON.stringify(data);
    return service.post('/api/channel/getUserInfo', {param: json});
};


//用户余额
export const yue = (data) => {
    const json = JSON.stringify(data);
    return service.post('/api/channel/yue', {param: json});
};

//账单明细
export const liushuiList = (data) => {
    const json = JSON.stringify(data);
    return service.post('/api/channel/liushuiList', {param: json});
};


//平台设置
export const getPingtaiSetting = (data) => {
    return serviceForm.post('/api/pingtai/getValueByKey', data);
};

//提现
export const tixian = (data) => {
    const json = JSON.stringify(data);
    return service.post('/api/channel/tixian', {param: json});
};

//提现详情
export const getTixianInfo = (data) => {
    const json = JSON.stringify(data);
    return service.post('/api/channel/getTixianInfo', {param: json});
};